import { useReducer } from 'react'
import { Provider } from 'react-redux';

import { AppRouter } from './routers/AppRouter'
import { store } from './store/store';
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";

import i18n from "./i18n/index";  


export const FixatgeApp = () => {



    return (
        
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <AppRouter />
            </I18nextProvider>
         </Provider>
      
    )
}
